


































import { Component, Vue } from "vue-property-decorator";

import MCartCustomer from "@/model/mCartcustomer";

@Component({
  name: "AdminCustomerIdDetail",
})
export default class AdminCustomerIdDetail extends Vue {
  public isShow = false;
  public adminCustomer: MCartCustomer = new MCartCustomer();

  public async show(adminCustomer: MCartCustomer = null) {
    this.isShow = true;
    this.adminCustomer = adminCustomer;
  }
}
